<template>
  <div>
    <div v-show="isShow == 'staging'|| isShow == 'local'">
      {{res}}
      <p style="color: red">{{wechatRes}}</p>
    </div>
  </div>
</template>

<script>
  import axios from "axios"
  import api from "../../api/api-list";

  export default {
    name: "WechatPay",
    data() {
      return {
        code: "",
        state: "",
        openid: "",
        result: "",
        res: "",
        wechatRes: '',
        isShow: process.env.VUE_APP_ENV,
        memberType: ''
      }
    },
    async mounted() {
      let {code, state} = this.$route.query
      this.code = code;
      this.state = state;
      let {orderId = '', coupon_id = '', type, isSuper, isSuperPlus, repurchase_discount, memberType = '', hasRights = '' } = state ? JSON.parse(state) : {}
      let res = null
      this.memberType = memberType || ''
      this.$db.ls.remove('member_isSuper')
      this.$db.ls.remove('member_isSuperPlus')
      // c端 导师支付
      if (type === 'mentor') {
        res = await api.global.mentorOrderPay(orderId, {pay_type: 'wxpay', coupon_id,code})
      // c端 会员支付
      } else if (type === 'member') {
        res = await api.global.orderPay(orderId, {pay_type: 'wxpay', coupon_id,code, repurchase_discount: !repurchase_discount || repurchase_discount === '0' ? 0 : 1})
        // 如果是终身会员
        if (isSuper === 'isSuper') {
          this.$db.ls.set('member_isSuper',isSuper)
        }
        // 如果是终身会员
        if (isSuperPlus === 'isSuperPlus') {
          this.$db.ls.set('member_isSuperPlus', isSuperPlus)
        }
      // b端 职位置顶 和 发布火爆职位 购买查看电话次数
      } else if (type === 'bJobHot' || type === 'bJobTop' || type === 'bHotAndTop' || type === 'bPhone' || type === 'bJobRefresh') {
        // let tempres = await api.global.updateOrderStatus({order_token: orderId})
        // if(tempres.code !== 1000) {
        //   alert(JSON.stringify(res))
        //   return
        // }
        res = await api.global.bJobOrderPay(orderId, {pay_type: 'wxpay', coupon_id,code})
      // c端 照片美颜
      } else if (type === 'cPhotoBeauty') {
        res = await api.global.orderPay(orderId, {pay_type: 'wxpay', coupon_id,code})
      }
      this.res = res
      let {data: {result}} = res
      this.result = result
      let {app_id, mch_id, nonce_str, prepay_id, h5_sign, time_stamp} = result
      let _this = this
      WeixinJSBridge.invoke('getBrandWCPayRequest', {
        "appId": app_id,
        "timeStamp": time_stamp,
        "nonceStr": nonce_str,
        "package": 'prepay_id=' + prepay_id,
        "signType": "MD5",
        "paySign": h5_sign
      }, function (res) {
        this.wechatRes = res
        if(res.err_msg == "get_brand_wcpay_request:ok" ) {
          // 支付成功 跳转到支付成功页面
          if (type === 'member') {
            _this.$router.push({path: '/pay/wechat/success', query: { origin: 'member', memberType, hasRights }})
          } else if (type === 'bJobHot') {
            _this.$router.push({path: '/pay/wechat/success', query: {origin: 'bJobHot'}})
          } else if (type === 'bJobTop') {
            _this.$router.push({path: '/pay/wechat/success', query: {origin: 'bJobTop'}})
          } else if (type === 'bHotAndTop') {
            _this.$router.push({path: '/pay/wechat/success', query: {origin: 'bHotAndTop'}})
          } else if (type === 'mentor') {
            _this.$router.push({path: '/pay/wechat/success', query: {origin: 'mentor'}})
          } else if (type === 'cPhotoBeauty') {
            _this.$router.push({path: '/pay/wechat/success', query: {origin: 'cPhotoBeauty'}})
          } else if (type === 'bJobRefresh') {
            _this.$router.push({path: '/pay/wechat/success', query: {origin: 'bJobRefresh'}})
          } else if (type === 'bPhone') {
            _this.$router.push({path: '/pay/wechat/success', query: {origin: 'bPhone'}})
          }

        } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
          // 取消支付 后的操作
          alert("您取消了支付")
          if (type === 'bJobHot' || type === 'bJobTop' || type === 'bHotAndTop') {
            window.location.href = window.location.origin.replace("m", "hr")
          } else if (type === 'cPhotoBeauty') {
            window.location.href = window.location.origin
          } else {
            _this.$router.push("/buy/member/order")
          }
        } else {
          alert('对不起，您支付失败！');
        }
      });
    }
  }
</script>

<style scoped>

</style>
